/* eslint-disable  */
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import Loader from "../../Components/Loader";
import { dataActionCreators } from "../../services/Actions";
import "../css/fundDed.css";
import "../css/pages.css";
import RenderAdminPage from "../RenderAdminPage";
function UPNMGMembers() {
  const dispatch = useDispatch();
  const { GetAllFunds, GetMembers, DownloadMTNUsers } = bindActionCreators(
    dataActionCreators,
    dispatch
  );
  const [limit, setLimit] = useState(20);
  const [search, setSearch] = useState(null);
  const [pageRange, setPageRange] = useState({
    page: 1,
    totalToShow: 1,
  });
  const data = useSelector((state) => state.data);
  // const paginate = data?.paginate;
  const { members, paginate, isLoading } = data;
  console.log("paginate", paginate);

  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = limit;
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    // Fetch items from another resources.
    const endOffset = itemOffset + itemsPerPage;

    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    setCurrentItems(members?.slice(itemOffset, endOffset));
    setPageCount(Number(paginate?.total));
  }, [itemOffset, itemsPerPage, members]);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    console.log("event", event);

    GetMembers(true, event.selected + 1, limit);

    console.log("currentPage", currentPage);

    const newOffset = (event.selected * itemsPerPage) % paginate?.total;

    setItemOffset(newOffset);
  };

  const handleLimit = (e) => {
    setLimit(e.target.value);
  };
  //TODO:: IMPLEMENT SEARCH FUNCTIONALITY ON THE BACKEND
  const onSearchTextChange = debounce((e) => {
    if (e?.target?.value) {
      setSearch(e?.target?.value ?? null);
      console.log("search", search);
      console.log("e?.target?.value", e?.target?.value);
      GetMembers(
        true,
        1,
        15,
        `${e?.target?.value ? "&search=" + e?.target?.value : ""}`
      );
    } else {
      setSearch(null);
      GetMembers(true, 1, 15, null);
    }
  }, 800);

  useEffect(() => {
    GetMembers(true, 1, limit);
  }, []);

  useEffect(() => {
    GetMembers(true, 1, limit);
  }, [limit]);

  return (
    <div>
      <RenderAdminPage title="UPNMG Members">
        {isLoading && <Loader />}

        <div className="flex flex-col sm:flex-row gap-3 mb-6">
          <div className="flex-1">
            <label htmlFor="search" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Search</label>
            <input
              type="search"
              onChange={onSearchTextChange}
              id="search"
              placeholder="Search by staff ID, name..."
              className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all placeholder:text-slate-400"
            />
          </div>
          <div className="w-full sm:w-40">
            <label htmlFor="limit" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Show</label>
            <select className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all" onChange={handleLimit}>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={25}>25</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={200}>200</option>
              <option value={250}>250</option>
            </select>
          </div>
          <div className="flex items-end">
            <button
              className="px-4 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold transition-colors shadow-sm"
              onClick={() => DownloadMTNUsers()}
            >
              MTN Users
            </button>
          </div>
        </div>

        <div className="flex justify-between items-center mb-4">
          <p className="text-sm text-slate-500 dark:text-slate-400">{members?.length || 0} records</p>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-slate-200 dark:border-gray-700 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-slate-50 dark:bg-gray-700/50">
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Member Info</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Email</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">District</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Department</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Facility</th>
                  <th className="px-4 py-3"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-gray-700">
                {members?.length > 0 ? (
                  <>
                    {members?.map((member, index) => (
                      <tr key={index + 1} className="hover:bg-slate-50 dark:hover:bg-gray-700/30 transition-colors">
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-3">
                            <img className="w-9 h-9 rounded-full object-cover" src={member?.profile_image || "/images/dev/avarta2.jpeg"} alt="" />
                            <div>
                              <p className="text-sm font-medium text-slate-800 dark:text-slate-200">{member?.name}</p>
                              <p className="text-xs text-slate-500 dark:text-slate-400 font-semibold">{member?.staff_id}</p>
                            </div>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-sm text-slate-700 dark:text-slate-300">{member?.email}</td>
                        <td className="px-4 py-3 text-sm text-slate-700 dark:text-slate-300">{member?.district}</td>
                        <td className="px-4 py-3 text-sm text-slate-700 dark:text-slate-300">{member?.department}</td>
                        <td className="px-4 py-3 text-sm text-slate-700 dark:text-slate-300">{member?.facility}</td>
                        <td className="px-4 py-3 text-right">
                          <button type="button" className="text-slate-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors">
                            <svg className="h-5 w-5 fill-current" viewBox="0 0 24 24"><path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" /></svg>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </>
                ) : (
                  <tr><td colSpan="6" className="px-4 py-12 text-center text-sm text-slate-400 dark:text-slate-500">No data available</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {members?.length > 0 && (
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="<"
            renderOnZeroPageCount={null}
            containerClassName="pagination"
            pageLinkClassName="page-num"
            previousLinkClassName="page-num"
            nextLinkClassName="page-num"
            activeLinkClassName="active"
          />
        )}
      </RenderAdminPage>
    </div>
  );
}

export default UPNMGMembers;
